import { render, staticRenderFns } from "./mineExchange.vue?vue&type=template&id=0db19c15&scoped=true"
import script from "./mineExchange.vue?vue&type=script&lang=js"
export * from "./mineExchange.vue?vue&type=script&lang=js"
import style0 from "./mineExchange.vue?vue&type=style&index=0&id=0db19c15&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db19c15",
  null
  
)

export default component.exports